import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { KPI_REQUEST } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const { GET_KPI, POST_KPI, PUT_KPI, DELETE_KPI } = KPI_REQUEST;

export const kpiApi = createApi({
  reducerPath: 'kpiApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getKPI: builder.query({
      query: (data) => ({ url: `${GET_KPI}${buildQueryString(data)}`, method: GET })
    }),
    addKPI: builder.mutation({
      query: (data) => ({ url: POST_KPI, method: POST, data })
    }),
    deleteKPI: builder.mutation({
      query: (id) => ({
        url: `${DELETE_KPI}/${id}`,
        method: DELETE
      })
    }),
    editKPI: builder.mutation({
      query: (data) => ({
        url: `${PUT_KPI}/${data.id}`,
        method: PUT,
        data: data.data
      })
    })
  })
});

export const { useGetKPIQuery, useAddKPIMutation, useEditKPIMutation, useDeleteKPIMutation } =
  kpiApi;
